__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shellApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations/browser", "20.3.27", () => (__webpack_require__.e(528).then(() => (() => (__webpack_require__(1147))))));
			register("@angular/animations", "20.3.27", () => (__webpack_require__.e(172).then(() => (() => (__webpack_require__(7172))))));
			register("@angular/cdk/a11y", "20.2.14", () => (__webpack_require__.e(459).then(() => (() => (__webpack_require__(2459))))));
			register("@angular/cdk/overlay", "20.2.14", () => (__webpack_require__.e(763).then(() => (() => (__webpack_require__(5763))))));
			register("@angular/cdk/portal", "20.2.14", () => (__webpack_require__.e(168).then(() => (() => (__webpack_require__(9168))))));
			register("@angular/common/http", "20.3.27", () => (__webpack_require__.e(15).then(() => (() => (__webpack_require__(8015))))));
			register("@angular/common", "20.3.27", () => (__webpack_require__.e(610).then(() => (() => (__webpack_require__(7610))))));
			register("@angular/core/primitives/di", "20.3.27", () => (__webpack_require__.e(248).then(() => (() => (__webpack_require__(2867))))));
			register("@angular/core/primitives/signals", "20.3.27", () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(5689))))));
			register("@angular/core", "20.3.27", () => (__webpack_require__.e(17).then(() => (() => (__webpack_require__(7017))))));
			register("@angular/platform-browser/animations", "20.3.27", () => (__webpack_require__.e(216).then(() => (() => (__webpack_require__(3835))))));
			register("@angular/platform-browser", "20.3.27", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(436))))));
			register("@angular/router", "20.3.27", () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(6039))))));
			register("@ngx-translate/core", "16.0.4", () => (__webpack_require__.e(884).then(() => (() => (__webpack_require__(8503))))));
			register("@siemens/element-ng/common", "48.11.0", () => (__webpack_require__.e(932).then(() => (() => (__webpack_require__(1551))))));
			register("@siemens/element-ng/loading-spinner", "48.11.0", () => (__webpack_require__.e(803).then(() => (() => (__webpack_require__(7184))))));
			register("@siemens/element-ng/modal", "48.11.0", () => (__webpack_require__.e(60).then(() => (() => (__webpack_require__(5679))))));
			register("@siemens/element-ng/skip-links", "48.11.0", () => (__webpack_require__.e(646).then(() => (() => (__webpack_require__(265))))));
			register("rxjs/operators", "7.8.2", () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(3620))))));
			register("rxjs", "7.8.2", () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(1340))))));
			register("tslib", "2.8.1", () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(4398))))));
			initExternal(4286);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};